import { APIcaller } from '../commons/utils/APICaller';

export interface User {
  firstName: string;
  lastName: string;
  email: string;
  id: string;
  picture: string;
}

const inpulseClientLogin = async (clientId: string): Promise<{ accessToken: string }> =>
  APIcaller.apiGet('inpulse-accounts/client-login', { clientId });

export default {
  inpulseClientLogin
};
